<template>
    <div class="paymentMethod">
        <div class="col-md-12">
            <!-- alerta de comprobante
            <div class="orange-background">
                <span class="icon">
                    <v-icon color="white">mdi-exclamation</v-icon>
                </span>
              <span>Recuerda que vamos a solicitar tu comprobante de pago más adelante</span>
            </div>
            -->
            <div class="col-sm-30 col-md-12">
                <div class="row">
                    <div class="col-sm-6  justify-center">
                        <div class="title">
                            <span>Seleccione el medio de pago</span>
                        </div>
                        <v-select color="secondary" label="*Método de pago" placeholder="Selecciona el método de pago"
                            required :items="paymentMethod" item-text="paymentMethodName" item-value="paymentMethodId"
                            :rules="paymentMethodRules" v-model="paymentMethodId">
                        </v-select>
                    </div>

                    <div class="col-sm-5  justify-end">
                        <div class="subtotal-container">
                            <div class="subtotal-row">
                                <div class="subtotal-label">Subtotal</div>
                                <div class="subtotal-value">{{ formatMoney(valuesPayload.subTotal) }}</div>
                            </div>
                            <div class="subtotal-row">
                                <div class="subtotal-label">Valor de comisión</div>
                                <div class="subtotal-value">{{ formatMoney(valuesPayload.commission) }}</div>
                            </div>
                            <div class="subtotal-row">
                                <div class="subtotal-label">Valor de IVA</div>
                                <div class="subtotal-value">{{ formatMoney(valuesPayload.iva) }}</div>
                            </div>
                            <div class="subtotal-row total-row">
                                <div class="subtotal-label">Total a pagar</div>
                                <div class="subtotal-value">{{ formatMoney(valuesPayload.total) }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="img-btn">
            <template v-if="paymentMethodId === 1">
                <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn x-medium fixed rounded bottom right dark color="primary" v-bind="attrs" v-on="on"
                            @click="handlePayment">
                            Pagar
                        </v-btn>
                    </template>
                    <span>Pagar</span>
                </v-tooltip>
            </template>

            <template v-if="paymentMethodId === 2">
                <FormPaymentSupport :dialog="visible" :transactionProps="combinedTransactionProps" />
            </template>

            <template v-if="paymentMethodId === 3">
                <FormPaymentSupport :dialog="visible" :transactionProps="combinedTransactionProps" />
            </template>


        </div>
    </div>
</template>

<script>

import EventBus from '@/utils/event_bus.js';
import { mapActions, mapGetters } from "vuex";
import Swal from "sweetalert2";
import FormPaymentSupport from '@/views/recognition/pages/payment_support/detail_payment_support.vue';

import {
    RECOGNITION_BUYING_M,
    ACTION_GET_PAYMENTMETHON_LIST,
    GET_PAYMENTMETHON_LIST,

} from "@/views/recognition/store/types/types.js";

export default {

    components: {
        FormPaymentSupport
    },

    name: "addUserAffiliate",

    data() {
        return {
            visible: false,
            valuesPayload: {
                subTotal: 0,
                //IVA: 0,
                transactionId: 0,
                total: 0,
                commission: 0,
            },
            paymentMethodId: null,
            paymentMethodName: null,
            paymentMethodRules: [
                v => !!v || "Método de pago requerido"
            ],
            showErrorMessages: false
        };

    },

    async mounted() {
        await this.getActionpaymentMethod();
    },

    created() {
        EventBus.$on('modal-payload', (payload) => {
            this.valuesPayload = payload;
        });
    },

    methods: {
        ...mapActions({
            getActionpaymentMethod: `${RECOGNITION_BUYING_M}${ACTION_GET_PAYMENTMETHON_LIST}`,
        }),

        formatMoney(number) {

            return "$" + number.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        handlePayment() {
            Swal.fire({
                title: 'Nos encontramos trabajando',
                icon: 'info',
                confirmButtonText: 'OK',
                confirmButtonColor: '#2778c4'
            });
        },
        handleRequest() {
            Swal.fire({
                title: 'Solicitud de compra',
                icon: 'info',
                confirmButtonText: 'OK',
                confirmButtonColor: '#2778c4'
            });
        },

        validateForm() {
            this.showErrorMessages = true;
            const errors = {};
            if (!this.paymentMethodName) {
                errors.paymentMethodName = 'Método de pago';
            }
            return errors;
        },

        openDialog() {
            this.visible = true;
        }

    },

    computed: {

        ...mapGetters({
            paymentMethod: [`${RECOGNITION_BUYING_M}${GET_PAYMENTMETHON_LIST}`],
        }),

        combinedTransactionProps() {
            const props = {
                paymentMethodId: this.paymentMethodId,
                transactionId: this.valuesPayload.transactionId
            };
            return props;
        }
    }
};

</script>


<style lang="css" scoped>
.col-md-7 {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 230px;
}

.row {
    display: flex;
    flex-wrap: wrap;
    gap: 50px;
    flex-direction: row;
    justify-content: flex-start;
    /* Asegura que los elementos se alineen al inicio */
    align-items: flex-start;
}

.custom-col {
    padding-left: 5px;
    padding-right: 5px;
}

/*Resposive*/
@media screen and (max-width: 912px) {
    .col-md-7 {
        gap: 40px;
    }
}

@media screen and (max-width: 820px) {
    .col-md-7 {
        gap: 40px;
    }
}

@media screen and (max-width: 768px) {
    .col-md-7 {
        gap: 40px;
    }
}


@media screen and (max-width: 425px) {

    .payment-method {
        display: inline;
        align-items: center;
        justify-content: center;
        flex-direction: row;

    }

}

.orange-background {
    background-color: rgba(255, 121, 0, 0.3);
    height: 3.5rem;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: #6E17A5;
    font-size: 1.1rem;
    padding: 0 1rem;
    font-weight: bold;
    border-radius: 8px;
    margin-bottom: 20px;
    flex-wrap: wrap;
    overflow-y: auto;
    max-height: 3.5rem;
}

.orange-background span {
    white-space: normal;
    /* Allow text to wrap */
    overflow: hidden;
    /* Ensure content doesn't overflow the container */
    text-overflow: ellipsis;
    /* Add ellipsis if the text overflows */
}

.title {
    height: 4rem;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: #6E17A5;
    font-weight: 500;
}

.icon {
    background-color: #FF7900;
    border-radius: 50%;
    padding: 0.1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    margin-right: 1rem;
    font-size: 1rem;
}

.payment-method {
    margin-right: 100px;
}

.totals {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    /* Asegura que los elementos se alineen al inicio */
    width: 100%
}

.subtotal-container {
    display: grid;
    grid-template-columns: auto 0.4fr;
    gap: 10%;
    margin-top: 5%;
    width: 100%;
}

.subtotal-row {
    display: contents;
}

.subtotal-label {
    font-weight: bold;
    text-align: end;
    color: #6E17A5;
}

.subtotal-value {
    text-align: end;
}

.subtotal-row.total-row {
    font-size: 1.5rem;
    margin-top: 2rem;
}

.subtotal-row.total-row .subtotal-label,
.subtotal-row.total-row .subtotal-value {
    font-size: 1.5rem;
}
</style>